<template>
    <div class="container">
        <ModelConfig :secTitle="'Selecione o <b>Motor</b> do seu <b>' + this.resumeData.model + '</b>'"
        :showLeftCol="showCarLook" :showRigthCol="showCarOptions">
            <template v-slot:carLook>
                <Model :isMobile="isMobile" :detailsContent="detailsContent" />
            </template>
            <template v-slot:carOptions>
                <p class="sidebarTitle"><b>Selecionar o {{ staticText.motorLabels[0] }}</b></p>
                <DetailsViewNav :isMobile="isMobile" :showContent="showCarOptions" @change-view="displayCarOptions">
                    <span><b>Selecionar {{ staticText.motorLabels[0] }}</b> ( {{ handleCarData.length }}  {{ staticText.motorLabels[1] }})</span>
                </DetailsViewNav>

                <FilterModel :campareLabel="staticText.motorLabels[1]"
                :itemsLenght="getModelEngines(resumeData.modelid).length"
                :transmission="setTransmissions"
                :selectedTransmission.sync="currTransmission"
                :prices.sync="currPrices"
                :rents.sync="currRents"
                :priceRange="handlePricesRanges"
                @filtered-lst="filteredCarData($event)"/>

                <ListConfigCards :cardData="handleCarData" :isMotorCard="true" :selectedOption="defineDefaultMotor"/>
            </template>
        </ModelConfig>
        <p v-show="showCarLook && isMobile" class="btn-secondary" @click="displayCarOptions">
            <span><b>Selecionar {{ staticText.motorLabels[0] }}</b> ({{ handleCarData.length }} {{ staticText.motorLabels[1] }})</span>
        </p>
        <div class="container-wrapContent">
            <FeaturedBlock :secTitle="dataBO.destaqueSect.destaqueTitle" :content="dataBO.destaqueSect.destaqueContent" />
            <Accordion :accordionObj="dataBO.faqs.faqsMotor" />
            <LegalMentions />
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapState } from 'vuex'
    import ModelConfig from '../components/TemplateParts/ModelConfig/ModelConfig.vue'
    import Model from '../components/TemplateParts/Model/Model.vue'
    import DetailsViewNav from '../components/TemplateParts/SimpleContent/DetailsViewNav.vue'
    import FilterModel from '../components/TemplateParts/FilterModel/FilterModel.vue'
    import ListConfigCards from '../components/TemplateParts/ListConfigCards/ListConfigCards.vue'
    import Accordion from '../components/TemplateParts/SimpleContent/Accordion.vue'
    import FeaturedBlock from '../components/TemplateParts/SimpleContent/FeaturedBlock.vue'
    import LegalMentions from '../components/TemplateParts/SimpleContent/LegalMentions.vue'
    import { comonFunctions } from '../mixins/comonFunctions'
    import { metatags } from '../mixins/comonMetaTags'
    import { mainFilterFunc } from '../mixins/filterFunctions'
    import { handleDataLayer } from '../mixins/handleDataLayer'

    export default {
        name: 'Motors',
        components:{ ModelConfig, Model, DetailsViewNav, FilterModel, ListConfigCards, Accordion, FeaturedBlock, LegalMentions },
        mixins: [ metatags, comonFunctions, mainFilterFunc, handleDataLayer ],
        data(){return{
            seoData: {
                "title": "Configurador",
                'titleTemplate': 'Motores',
                "author": "Hyundai Portugal",
                "og_description": "Com o Configurador Hyundai, pode escolher e personalizar o seu Hyundai de sonho. Selecione o seu modelo favorito e escolha todas as características de acordo com as suas preferências.",
                "og_title": "Configurador Hyundai - Hyundai Portugal",
                "og_locale": "pt_PT",
                "og_type": "article",
                "og_site_name": "Hyundai Portugal"
            },
            lenght: 2,
            currPage: 'Motor'
        }},
        mounted(){
            this.setDataLayerInitCfg();
        },
        beforeRouteLeave(to, prev, next){
            if(to.name == 'Resume'){
                alert('Selecione a versão!')
                this.$router.push({ name: 'Version' })
                return false
            }

            if((to.name == 'DesignExterior' || to.name == 'DesignInterior' ) && this.resumeData.versionID == undefined){
                this.$router.push({ name: 'Version' })
                alert('Selecione a versão!')
                return false
            }

            if(this.resumeData.isMotorSelected != true){
                alert('Selecione o motor!')
                return false
            }

            next()
        },
        provide:{
            page: 'Motor',
        },
        computed: {
            ...mapState(['resumeData']),
            ...mapGetters({
                detailsContent: 'resumeData/getModelDetailsContent',
                getModelEngines: 'enginesData/getEngines',
            }),
            handleCarData(){ //arr, bool transm or segm...
                let trmLgh = this.currTransmission.length;
                let priceLgh = this.currPrices.length;
                let rentLgh = this.currRents.length;
                let arrContent = this.getModelEngines(this.resumeData.modelid)

                if(trmLgh != 0){
                    let _content = this.filterByTransmission(arrContent)

                    if(priceLgh != 0){
                        let _array = this.filterByPrice(_content)
                        if(rentLgh != 0) return this.filterByRent(_array)
                        return _array
                    }

                    if(rentLgh != 0) return this.filterByRent(_content)
                    return _content
                }

                if(priceLgh != 0){
                    let _content = this.filterByPrice(arrContent)
                    if(rentLgh != 0) return this.filterByRent(_content)
                    return _content
                }

                if(rentLgh != 0) return this.filterByRent(arrContent)
                return arrContent
            },
            defineDefaultMotor(){
                let routeParamEngine = this.$route.params?.modelCompared
                return (routeParamEngine != undefined) ? routeParamEngine : this.resumeData.selectedEngine
            },
        },
        methods:{
            filteredCarData(e){
                this.filteredContent = e ? e : this.tempCarData
            },
        }
    }
</script>
